import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment, createVNode as _createVNode, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "alert-details" }
const _hoisted_2 = { class: "card mb-3 telegram-message" }
const _hoisted_3 = { class: "card-header bg-primary bg-gradient text-white" }
const _hoisted_4 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "d-flex align-items-center gap-2" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "badge bg-white text-dark" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = {
  key: 0,
  class: "mb-2",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_11 = { class: "mt-3" }
const _hoisted_12 = {
  key: 1,
  class: "row g-2"
}
const _hoisted_13 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_14 = { class: "badge bg-secondary" }
const _hoisted_15 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_16 = {
  key: 2,
  class: "col-auto"
}
const _hoisted_17 = ["title"]
const _hoisted_18 = {
  key: 3,
  class: "col-auto"
}
const _hoisted_19 = { class: "badge bg-info" }
const _hoisted_20 = {
  key: 0,
  class: "col-auto"
}
const _hoisted_21 = { class: "badge bg-dark" }
const _hoisted_22 = {
  key: 1,
  class: "col-auto"
}
const _hoisted_23 = { class: "badge bg-secondary" }
const _hoisted_24 = {
  key: 2,
  class: "col-auto"
}
const _hoisted_25 = { class: "badge bg-info" }
const _hoisted_26 = {
  key: 3,
  class: "col-auto"
}
const _hoisted_27 = { class: "badge bg-warning" }
const _hoisted_28 = {
  key: 0,
  class: "col-lg-6 mt-3 mt-lg-0"
}
const _hoisted_29 = { class: "d-flex flex-wrap gap-2" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "d-flex justify-content-between align-items-center w-100 mt-1" }
const _hoisted_32 = {
  class: "text-muted",
  style: {"font-size":"0.75rem"}
}
const _hoisted_33 = ["disabled", "onClick"]
const _hoisted_34 = { class: "mt-3" }
const _hoisted_35 = { class: "d-flex justify-content-between align-items-center flex-wrap gap-2" }
const _hoisted_36 = { class: "d-flex gap-2" }
const _hoisted_37 = ["title"]
const _hoisted_38 = { class: "small" }
const _hoisted_39 = ["title"]
const _hoisted_40 = { class: "small" }
const _hoisted_41 = {
  key: 0,
  class: "fas fa-robot"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_45 = { class: "d-flex align-items-center gap-2" }
const _hoisted_46 = ["disabled", "onClick"]
const _hoisted_47 = { class: "badge bg-white text-dark" }
const _hoisted_48 = { class: "card-body" }
const _hoisted_49 = {
  key: 0,
  style: {"white-space":"pre-wrap"}
}
const _hoisted_50 = {
  key: 1,
  class: "mt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertEditForm = _resolveComponent("AlertEditForm")!
  const _component_MediaDisplay = _resolveComponent("MediaDisplay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("small", null, [
            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-bell me-1" }, null, -1)),
            _createTextVNode(" Alerta Original - " + _toDisplayString(_ctx.formatDateTime(_ctx.alert.mainMessage.date)), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.showReprocessButtons && _ctx.canReanalyzeAlerts)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-sm btn-link text-white p-0 text-decoration-none",
                  disabled: _ctx.isReprocessing[_ctx.alert.mainMessage.messageId],
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('reprocess-message', _ctx.alert.mainMessage)), ["stop"])),
                  title: "Reprocesar con IA"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fas fa-robot", {
                  'fa-spin': _ctx.isReprocessing[_ctx.alert.mainMessage.messageId],
                }])
                  }, null, 2)
                ], 8, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("small", _hoisted_7, " #" + _toDisplayString(_ctx.alert.mainMessage.messageId), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass([
              (_ctx.alert.mainMessage.mediaType &&
                _ctx.alert.mainMessage.mediaType !== 'none') ||
              _ctx.getMediaOnlyLinkedMessages(_ctx.alert).length > 0
                ? 'col-lg-6'
                : 'col-12',
            ])
          }, [
            (_ctx.alert.mainMessage.text)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.cleanAlertText(_ctx.alert.mainMessage.text)), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_ctx.isEditing)
                ? (_openBlock(), _createBlock(_component_AlertEditForm, {
                    key: 0,
                    "initial-data": _ctx.alertEditData,
                    "alert-type": _ctx.currentAlertType,
                    "is-saving": _ctx.isSaving,
                    onSave: _ctx.onSaveEdit,
                    onCancel: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('cancel-edit')))
                  }, null, 8, ["initial-data", "alert-type", "is-saving", "onSave"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (
                    _ctx.currentAlertType === 'forex' ||
                    _ctx.currentAlertType === 'synthetic_indices'
                  )
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.alert.mainMessage.pair || _ctx.alert.mainMessage.index), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.alert.mainMessage.direction)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", 
                        _ctx.alert.mainMessage.direction?.toLowerCase() === 'buy'
                          ? 'bg-success'
                          : 'bg-danger'
                      ])
                                }, _toDisplayString(_ctx.alert.mainMessage.direction), 3)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.alert.mainMessage.orderType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["badge", 
                        _ctx.getOrderTypeBadgeClass(_ctx.alert.mainMessage.orderType)
                      ]),
                                  title: _ctx.getOrderTypeLabel(_ctx.alert.mainMessage.orderType)
                                }, _toDisplayString(_ctx.getOrderTypeLabel(_ctx.alert.mainMessage.orderType)), 11, _hoisted_17)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.alert.mainMessage.timeframe)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.alert.mainMessage.timeframe), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          (_ctx.alert.mainMessage.sport)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.alert.mainMessage.sport), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                      _ctx.alert.mainMessage.teams &&
                      _ctx.alert.mainMessage.teams.length > 0
                    )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.alert.mainMessage.teams.join(" vs ")), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.alert.mainMessage.betType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.alert.mainMessage.betType), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.alert.mainMessage.selection)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.alert.mainMessage.selection), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                  ]))
            ])
          ], 2),
          (
              (_ctx.alert.mainMessage.mediaType &&
                _ctx.alert.mainMessage.mediaType !== 'none') ||
              _ctx.getMediaOnlyLinkedMessages(_ctx.alert).length > 0
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  (
                  _ctx.alert.mainMessage.mediaType &&
                  _ctx.alert.mainMessage.mediaType !== 'none'
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(_component_MediaDisplay, {
                          "media-type": _ctx.alert.mainMessage.mediaType || 'none',
                          "storage-path": _ctx.alert.mainMessage.storagePath
                        }, null, 8, ["media-type", "storage-path"])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMediaOnlyLinkedMessages(_ctx.alert), (relMsg) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: relMsg.messageId,
                      class: "d-flex flex-column align-items-center"
                    }, [
                      _createVNode(_component_MediaDisplay, {
                        "media-type": relMsg.mediaType || 'none',
                        "storage-path": relMsg.storagePath
                      }, null, 8, ["media-type", "storage-path"]),
                      _createElementVNode("div", _hoisted_31, [
                        _createElementVNode("small", _hoisted_32, " #" + _toDisplayString(relMsg.messageId), 1),
                        (_ctx.showReprocessButtons)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "btn btn-sm btn-link text-secondary p-0 text-decoration-none",
                              disabled: _ctx.isReprocessing[relMsg.messageId],
                              onClick: _withModifiers(($event: any) => (_ctx.$emit('reprocess-message', relMsg)), ["stop"]),
                              title: "Reprocesar con IA"
                            }, [
                              _createElementVNode("i", {
                                class: _normalizeClass(["fas fa-robot", {
                        'fa-spin': _ctx.isReprocessing[relMsg.messageId],
                      }])
                              }, null, 2)
                            ], 8, _hoisted_33))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                (_ctx.canEditAlerts)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["btn btn-sm d-flex align-items-center gap-2", _ctx.isEditing ? 'btn-danger' : 'btn-outline-primary']),
                      onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
                    _ctx.isEditing
                      ? _ctx.$emit('cancel-edit')
                      : _ctx.$emit('start-edit', _ctx.alert)
                  ), ["stop"])),
                      title: _ctx.isEditing ? 'Cancelar edición' : 'Editar alerta'
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-fw", _ctx.isEditing ? 'fa-times' : 'fa-edit'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.isEditing ? "Cancelar" : "Editar"), 1)
                    ], 10, _hoisted_37))
                  : _createCommentVNode("", true),
                (_ctx.canReanalyzeAlerts)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["btn btn-sm d-flex align-items-center gap-2", 
                    _ctx.showReprocessButtons
                      ? 'btn-outline-warning'
                      : 'btn-outline-secondary'
                  ]),
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.showReprocessButtons = !_ctx.showReprocessButtons), ["stop"])),
                      title: 
                    _ctx.showReprocessButtons
                      ? 'Ocultar controles de IA'
                      : 'Mostrar controles de IA'
                  
                    }, [
                      _createElementVNode("i", {
                        class: _normalizeClass(["fas fa-fw", _ctx.showReprocessButtons ? 'fa-times' : 'fa-robot'])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.showReprocessButtons ? "Ocultar IA" : "Reprocesar IA"), 1),
                      (_ctx.showReprocessButtons)
                        ? (_openBlock(), _createElementBlock("i", _hoisted_41))
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_39))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.alert.mainMessage.aiConfidence !== undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted me-2" }, [
                      _createElementVNode("i", { class: "fas fa-robot me-1" }),
                      _createTextVNode(" Confianza IA: ")
                    ], -1)),
                    _createElementVNode("span", {
                      class: _normalizeClass(["badge", 
                    _ctx.getConfidenceBadgeClass(_ctx.alert.mainMessage.aiConfidence)
                  ])
                    }, _toDisplayString((_ctx.alert.mainMessage.aiConfidence * 100).toFixed(0)) + "% ", 3)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_43, [...(_cache[6] || (_cache[6] = [
                    _createElementVNode("span", { class: "text-muted small" }, " Sin información de confianza ", -1)
                  ]))]))
            ])
          ])
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTextRelatedMessages(_ctx.alert), (relMsg) => {
      return (_openBlock(), _createElementBlock("div", {
        key: relMsg.messageId,
        class: "card mb-2 telegram-message"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["card-header", {
          'bg-success bg-gradient text-white':
            relMsg.messageType === 'result' &&
            (relMsg.resultStatus === 'win' || relMsg.resultStatus === 'profit'),
          'bg-danger bg-gradient text-white':
            relMsg.messageType === 'result' && relMsg.resultStatus === 'loss',
          'bg-secondary bg-gradient text-white':
            relMsg.messageType === 'result' && relMsg.resultStatus === 'void',
          'bg-warning bg-gradient text-white':
            relMsg.messageType === 'result' &&
            relMsg.resultStatus === 'breakeven',
          'bg-info bg-gradient text-white': relMsg.messageType !== 'result',
        }])
        }, [
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("small", null, [
              _createElementVNode("i", {
                class: _normalizeClass([_ctx.getMessageTypeIcon(relMsg.messageType), "me-1"])
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(_ctx.getMessageTypeLabel(relMsg.messageType)) + " - " + _toDisplayString(_ctx.formatDateTime(relMsg.date)), 1)
            ]),
            _createElementVNode("div", _hoisted_45, [
              (_ctx.showReprocessButtons && _ctx.canReanalyzeAlerts)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "btn btn-sm btn-link text-white p-0 text-decoration-none",
                    disabled: _ctx.isReprocessing[relMsg.messageId],
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('reprocess-message', relMsg)), ["stop"]),
                    title: "Reprocesar con IA"
                  }, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-robot", {
                  'fa-spin': _ctx.isReprocessing[relMsg.messageId],
                }])
                    }, null, 2)
                  ], 8, _hoisted_46))
                : _createCommentVNode("", true),
              _createElementVNode("small", _hoisted_47, " #" + _toDisplayString(relMsg.messageId), 1)
            ])
          ])
        ], 2),
        _createElementVNode("div", _hoisted_48, [
          (relMsg.text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_49, _toDisplayString(relMsg.text), 1))
            : _createCommentVNode("", true),
          (relMsg.mediaType && relMsg.mediaType !== 'none')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                _createVNode(_component_MediaDisplay, {
                  "media-type": relMsg.mediaType || 'none',
                  "storage-path": relMsg.storagePath
                }, null, 8, ["media-type", "storage-path"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ]))
}